import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const deleteIntegration = async (params) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteTestSuiteIntegration&companyid=${user.companyid}&tsuid=${params.tsuid}`,
  );

  return response.data;
};

const useDeleteTestSuiteIntegration = ({ onSuccess, onError } = {}) => {
  const mutation = useMutation({
    mutationFn: deleteIntegration,
    onSuccess,
    onError,
  });

  return {
    ...mutation,
    mutate: mutation.mutate,
  };
};

export default useDeleteTestSuiteIntegration;
